/**
* Copyright (c) 2019 Vendor Badge, LLC All Rights Reserved.
* Created Date: Sunday, 7th April 2019
* 
* Generic Error Boundary
* Note: General Error that logs to Sentry and shows simple error snackbar.
*/
import React from 'react';
import * as Sentry from '@sentry/browser';
import { inject } from 'mobx-react';

class CatchError extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false,
      error: null,
      info: null,
    };
  }

  componentDidCatch(error, info) {
    // Update local state
    this.setState({ error: error, info: info });

    // Check to see if Sentry is enabled
    if (process.env.REACT_APP_SENTRY) {
      // Sentry Scope
      Sentry.configureScope((scope) => {

        // User (Auth or Anonymous)
        if (this.props.store.sessionStore.authUser) {
          scope.setTag('userId', this.props.store.sessionStore.authUser.id);
          scope.setTag('userEmail', this.props.store.sessionStore.authUser.email);
        } else {
          scope.setTag('user', 'anonymous');
        }
        // Session ID
        scope.setTag('sessionId', this.props.store.sessionStore.id)
        // Thumbprint
        scope.setTag('thumbprint', this.props.store.deviceStore.thumbprint);
        // Language
        scope.setTag('language', this.props.store.deviceStore.language);
        // Browser
        scope.setTag('browser', this.props.store.deviceStore.browser);
        // Engine
        scope.setTag('engine', this.props.store.deviceStore.engine);
        // OS
        scope.setTag('os', this.props.store.deviceStore.os);
        // Plugins
        scope.setTag('plugins', this.props.store.deviceStore.plugins);
      });
      
      Sentry.captureException(error);
      Sentry.captureMessage(info);
    }
  }

  render() {

    // Error Path
    if (this.state.hasError) {
      this.props.store.portalStore.snackbar.showSnackbarWithDismiss('We apologize, something went wrong.', 'error');
      return;
    }
    // Error Free Path
    return this.props.children;
  }
}

export default inject('store')(CatchError);
